export default {
    'AUTH.RESET_PASSWORD.TITLE': 'Reset my password',

    'AUTH.RESET_PASSWORD.FORM.PASSWORD_NEW.LABEL': 'Confirm your new password',

    'AUTH.RESET_PASSWORD.BUTTON': 'Confirm',
};
